import { usePetitionCommentsPageData, usePetitionCommentsPageState } from 'src/app/pages/petition/comments/pageContext';

type Result = ModelHookResult<{
	showDeleteConfirmMessage: boolean;
	showUnderReviewBanner: boolean;
}>;

export function usePageBanner(): Result {
	const [{ deleteConfirmMessage }] = usePetitionCommentsPageState();
	const {
		data: {
			petition: { status },
		},
	} = usePetitionCommentsPageData();

	return {
		data: {
			showDeleteConfirmMessage: deleteConfirmMessage,
			showUnderReviewBanner: status === 'UNDER_REVIEW',
		},
	};
}
